/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { GitCredentialResource } from "@octopusdeploy/octopus-server-client";
import { GitCredentialAuthenticationType } from "@octopusdeploy/octopus-server-client";
import { PlatformHubGitCredentialPage } from "./PlatformHubGitCredentialPage";
const emptyModel: GitCredentialResource = {
    Id: null!,
    SpaceId: "",
    Name: "",
    Description: "",
    Details: {
        Type: GitCredentialAuthenticationType.UsernamePassword,
        Username: null!,
        Password: null!,
    },
    RepositoryRestrictions: {
        Enabled: false,
        AllowedRepositories: [],
    },
    Links: null!,
};
export function PlatformHubCreateGitCredentialPage() {
    return <PlatformHubGitCredentialPage isCreate loaderData={{ gitCredential: emptyModel }}/>;
}
